import { getModel } from '@picsart/ai-sdk';

import { resolveModelId } from './constants';

function parseRatio(label: string): number | null {
  const [w, h] = label.split(':').map(Number);
  if (!w || !h) return null;
  return w / h;
}

/** Closest supported aspect-ratio to a source image's dimensions, by log-distance. */
export function pickAspectRatio(width: number, height: number, supported: string[]): string | null {
  if (!supported.length || width <= 0 || height <= 0) return null;

  const sourceLog = Math.log(width / height);
  let best: string | null = null;
  let bestDist = Infinity;

  supported.forEach(option => {
    const ratio = parseRatio(option);
    if (ratio === null) return;
    const dist = Math.abs(sourceLog - Math.log(ratio));
    if (dist < bestDist) {
      bestDist = dist;
      best = option;
    }
  });

  return best;
}

/** Aspect ratios a model supports, from its SDK param descriptor (empty if the model is fixed-ratio). */
export function getSupportedAspectRatios(modelId: string): string[] {
  const resolvedId = resolveModelId(modelId);
  const model = getModel(resolvedId);
  const descriptor = model?.paramConfig?.aspectRatio?.descriptor;
  if (!descriptor || descriptor.kind !== 'enum') return [];
  // options is EnumOption<string>[] | EnumOption<number>[]; normalize to a common shape.
  const options = descriptor.options as Array<{ id: string | number; disabled?: boolean }>;
  return options.filter(opt => !opt.disabled).map(opt => String(opt.id));
}
